import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "news-1",
    title: "《星海启航》新一季制作决定，星际冒险再起航",
    cover:
      "https://readdy.ai/api/search-image?query=space%20anime%20key%20visual%20with%20a%20starship%20sailing%20through%20a%20colorful%20nebula%2C%20orange%20and%20teal%20cosmic%20tones%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=640&height=400&seq=news-cover-01&orientation=landscape",
    summary:
      "官方正式公布《星海启航》第二季制作计划，原班声优阵容回归，故事将深入坍缩星域。",
    content: [
      "在刚刚结束的动漫嘉年华盛典上，制作方正式宣布《星海启航 Starsea Voyage》将推出全新一季。预告片中，风信子号缓缓驶入汹涌的星云，画面质感全面升级。",
      "据主创团队透露，新一季的剧情将围绕古老星图的真正秘密展开，星野遥与莉亚的关系也会迎来重要转折。原班声优林泽言、苏晴确认回归。",
      "制作方表示，新一季预计于明年春季与观众见面，同时会推出主题曲单曲。更多详情将在下月的特别直播中公布。",
    ],
    publishTime: "2025-10-08",
    category: "新番情报",
    author: "风车编辑部",
    views: 15200,
  },
  {
    id: "news-2",
    title: "《苍穹之翼》完结特别访谈：主创谈羽翼的隐喻",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20anime%20key%20visual%20of%20a%20winged%20girl%20soaring%20above%20floating%20islands%20at%20sunset%2C%20warm%20orange%20sky%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=640&height=400&seq=news-cover-02&orientation=landscape",
    summary:
      "《苍穹之翼》圆满收官，主创团队分享“羽翼”象征自由与责任的创作初衷。",
    content: [
      "《苍穹之翼 Skywing Chronicles》以艾莉娅最终展开双翼守护天空之城的一幕收尾，播出当晚登上多个平台的热搜。",
      "导演在特别访谈中表示，“羽翼”并非单纯的战力设定，而是自由与责任的隐喻。艾莉娅每一次飞翔，都是一次对自我身份的确认。",
      "谈及是否有续作计划，主创团队笑称“天空很大，故事还没讲完”，并感谢观众一路的陪伴。",
    ],
    publishTime: "2025-10-05",
    category: "深度访谈",
    author: "特约记者 青禾",
    views: 9800,
  },
  {
    id: "news-3",
    title: "年度动画大赏入围名单揭晓，《时空旅人》领跑",
    cover:
      "https://readdy.ai/api/search-image?query=awards%20ceremony%20banner%20with%20glowing%20trophy%20and%20floating%20time%20clock%20fragments%2C%20golden%20orange%20spotlight%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=640&height=400&seq=news-cover-03&orientation=landscape",
    summary:
      "本届年度动画大赏入围名单出炉，《时空旅人》《机械之心》等作品分列多项提名。",
    content: [
      "年度动画大赏组委会今日公布了完整入围名单，共有二十余部作品入围八个奖项。其中《时空旅人》以五项提名领跑，《机械之心》和《沙罗双树》紧随其后。",
      "今年的评审首次引入观众投票加权机制，观众票选结果将占总评分的三成，这也让不少小众佳作获得了更多曝光机会。",
      "颁奖典礼将于下月在滨海会展中心举行，届时将有主创红毯与现场演出。",
    ],
    publishTime: "2025-10-02",
    category: "业界动态",
    author: "风车编辑部",
    views: 13400,
  },
  {
    id: "news-4",
    title: "《机械之心》推出限定周边，温暖设计引热议",
    cover:
      "https://readdy.ai/api/search-image?query=merchandise%20display%20of%20a%20cute%20robot%20plush%20and%20keychains%20on%20a%20warm%20minimal%20shelf%2C%20soft%20cream%20and%20orange%20tones%2C%20clean%20background%2C%20product%20photography%20style%2C%20high%20detail&width=640&height=400&seq=news-cover-04&orientation=landscape",
    summary:
      "《机械之心》官方公布限定周边系列，主打“温暖陪伴”主题，预约首日即售罄。",
    content: [
      "《机械之心 Heart of Machine》官方周边系列正式开启预售，包含 R-07 造型毛绒玩偶、发光核心钥匙扣与主题明信片套装。",
      "设计团队表示，整套周边以“温暖陪伴”为核心，希望让观众把那份来自废墟的温柔带回现实生活。",
      "预售开启首日，多款商品即宣告售罄，官方随后宣布将进行第二批补货。",
    ],
    publishTime: "2025-09-28",
    category: "周边资讯",
    author: "风车周边组",
    views: 8900,
  },
  {
    id: "news-5",
    title: "《樱花剑姬》舞台剧定档，主视觉惊艳公开",
    cover:
      "https://readdy.ai/api/search-image?query=stage%20play%20key%20visual%20banner%20of%20a%20swordswoman%20in%20pink%20kimono%20under%20falling%20cherry%20blossoms%2C%20warm%20pink%20and%20orange%20stage%20lighting%2C%20clean%20minimal%20background%2C%20high%20detail&width=640&height=400&seq=news-cover-05&orientation=landscape",
    summary:
      "《樱花剑姬》真人舞台剧正式定档，官方公开主演阵容与主视觉海报。",
    content: [
      "改编自同名动画的《樱花剑姬》舞台剧正式定档，将于冬季在新月剧场上演。官方同步公开了主演阵容与主视觉海报。",
      "本次舞台剧在武打编排上邀请专业剑道指导参与，力求还原动画中樱花树下凌厉的剑戟对决。",
      "门票将于下周开启预售，主办方提示观众留意官方渠道以防购票诈骗。",
    ],
    publishTime: "2025-09-24",
    category: "演出活动",
    author: "特约记者 青禾",
    views: 7600,
  },
  {
    id: "news-6",
    title: "《甜梦烘焙屋》联动甜品店，现实版深夜烘焙屋开业",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20bakery%20counter%20with%20cakes%20and%20warm%20lights%20at%20night%2C%20soft%20cream%20and%20peach%20colors%2C%20clean%20minimal%20background%2C%20realistic%20food%20photography%2C%20high%20detail&width=640&height=400&seq=news-cover-06&orientation=landscape",
    summary:
      "《甜梦烘焙屋》与连锁甜品店联动，推出动画同款菜单并营业至深夜。",
    content: [
      "人气治愈番《甜梦烘焙屋》宣布与连锁甜品品牌展开联动，在全国多座城市打造“现实版深夜烘焙屋”。",
      "联动期间，店内将还原剧中出现的蜂蜜舒芙蕾与咸奶油蛋糕，并搭配限定包装与主题杯垫。",
      "活动主办方介绍，门店将营业至深夜十一点，希望为白天忙碌的人们留一盏温暖的灯。",
    ],
    publishTime: "2025-09-20",
    category: "联动活动",
    author: "风车编辑部",
    views: 10200,
  },
  {
    id: "news-7",
    title: "国漫《龙脊传说》宣布登陆海外平台",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20anime%20key%20visual%20of%20a%20warrior%20before%20a%20dragon-spine%20mountain%2C%20dramatic%20orange%20sky%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=640&height=400&seq=news-cover-07&orientation=landscape",
    summary:
      "国漫代表作《龙脊传说》宣布将在多国流媒体平台上线，并推出多语言配音版本。",
    content: [
      "国产奇幻动画《龙脊传说》正式宣布将登陆海外多国流媒体平台，覆盖日语、英语与西班牙语配音版本。",
      "制片方表示，作品以东方山水与成长叙事为核心，希望让更多海外观众感受到国漫的独特表达。",
      "为配合上线，官方还发布了一支国际版预告，画面中龙脊山的壮阔景象获得不少海外网友点赞。",
    ],
    publishTime: "2025-09-16",
    category: "业界动态",
    author: "风车编辑部",
    views: 11800,
  },
  {
    id: "news-8",
    title: "《时空旅人》主题曲MV公开，催泪弹幕刷屏",
    cover:
      "https://readdy.ai/api/search-image?query=music%20video%20visual%20with%20floating%20glowing%20clock%20fragments%20and%20soft%20bokeh%2C%20teal%20and%20orange%20gradient%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=640&height=400&seq=news-cover-08&orientation=landscape",
    summary:
      "《时空旅人》片尾主题曲完整 MV 正式公开，配合剧情的剪辑让弹幕区瞬间被“泪目”刷屏。",
    content: [
      "《时空旅人 Chrono Traveler》片尾主题曲《记住我》完整版 MV 正式上线。MV 以时野反复失去记忆的片段串联，配合旋律层层推进。",
      "歌曲由新生代唱作人演唱，上线数小时便登上多个音乐平台的新歌榜。评论区不少观众表示“听到副歌就绷不住了”。",
      "官方透露，完整版音源将于本月末在各大平台正式发行。",
    ],
    publishTime: "2025-09-12",
    category: "音乐情报",
    author: "风车音乐组",
    views: 14100,
  },
  {
    id: "news-9",
    title: "动漫嘉年华盛典落幕，现场人气爆棚",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20convention%20hall%20with%20crowds%20and%20colorful%20booths%20under%20warm%20orange%20lighting%2C%20clean%20bright%20interior%2C%20event%20photography%20style%2C%20high%20detail&width=640&height=400&seq=news-cover-09&orientation=landscape",
    summary:
      "为期三天的动漫嘉年华盛典圆满落幕，众多新番情报与限定周边引爆现场人气。",
    content: [
      "为期三天的动漫嘉年华盛典在会展中心圆满落幕。本届展会汇集了上百家展商与数十场主题舞台活动。",
      "现场不仅有大量新番情报发布，各展台的限定周边也吸引了排队长龙。cosplay 巡游更成为社交平台上的热门话题。",
      "主办方表示，下一届盛典将扩大展区面积，并新增独立游戏与同人创作专区。",
    ],
    publishTime: "2025-09-08",
    category: "漫展现场",
    author: "特约记者 青禾",
    views: 16700,
  },
  {
    id: "news-10",
    title: "《灵狐物语》作者分享创作手稿，和风美学受关注",
    cover:
      "https://readdy.ai/api/search-image?query=hand-drawn%20anime%20sketches%20of%20a%20white%20fox%20spirit%20and%20shrine%20forest%20on%20paper%2C%20warm%20sepia%20and%20orange%20tones%2C%20clean%20minimal%20desk%20background%2C%20high%20detail&width=640&height=400&seq=news-cover-10&orientation=landscape",
    summary:
      "《灵狐物语》原作者公开部分创作手稿，分享神社森林场景的灵感来源。",
    content: [
      "《灵狐物语 Spirit Fox Tale》原作者在社交平台公开了一组创作手稿，展示神社森林与灵狐形象从草图到定稿的过程。",
      "作者表示，场景灵感来自一次清晨的山间旅行，雾气中的鸟居与灯笼给她留下了深刻印象。",
      "不少读者在评论区称赞作品“每一帧都像一幅和风画作”，并期待后续剧情的发展。",
    ],
    publishTime: "2025-09-04",
    category: "创作手记",
    author: "风车编辑部",
    views: 7300,
  },
  {
    id: "news-11",
    title: "《赛博都市 2030》获国际动画节提名",
    cover:
      "https://readdy.ai/api/search-image?query=cyberpunk%20city%20skyline%20at%20night%20with%20neon%20holographic%20signs%20and%20rain%2C%20orange%20and%20teal%20neon%20reflections%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=640&height=400&seq=news-cover-11&orientation=landscape",
    summary:
      "《赛博都市 2030》凭借独特的美术风格，获得国际动画节最佳美术提名。",
    content: [
      "《赛博都市 2030 Cyber Metro 2030》入选某国际动画节主竞赛单元，并获最佳美术设计提名。",
      "评审团评价该作“以克制的霓虹色彩构建出潮湿而孤独的未来都市，视觉语言极具辨识度”。",
      "制作团队表示，这份肯定属于所有熬夜打磨每一帧的幕后成员。",
    ],
    publishTime: "2025-08-31",
    category: "业界动态",
    author: "风车编辑部",
    views: 9100,
  },
  {
    id: "news-12",
    title: "经典重制！《海之守望者》高清修复版上线",
    cover:
      "https://readdy.ai/api/search-image?query=remastered%20anime%20key%20visual%20of%20a%20lighthouse%20on%20a%20cliff%20over%20a%20turquoise%20ocean%20at%20sunset%2C%20warm%20orange%20sky%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=640&height=400&seq=news-cover-12&orientation=landscape",
    summary:
      "《海之守望者》宣布推出高清修复版本，重现灯塔少女的温柔守望。",
    content: [
      "经典治愈番《海之守望者 Ocean Keeper》宣布推出高清修复版，画面分辨率与色彩全面优化。",
      "修复团队表示，本次重制在保留原作手绘质感的前提下，提升了海浪与灯光的层次细节。",
      "高清版已在多个平台上线，同时附赠主创特别评论音轨。",
    ],
    publishTime: "2025-08-26",
    category: "新番情报",
    author: "风车编辑部",
    views: 6800,
  },
];